import { makeSelector } from 'containers/app/selectors'

const homeBuildingId = (state) =>
  state.getIn(['userSettings', 'homeBuildingId'])
const homeFloorId = (state) => state.getIn(['userSettings', 'homeFloorId'])

export const getHomeBuildingId = makeSelector(homeBuildingId)
export const getHomeFloorId = makeSelector(homeFloorId)
